"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Separator } from "@/components/ui/separator";
import { Link } from "@/components/common/Link";
export default function Biography() {
  const {
    ref: eyebrowRef,
    isVisible: eyebrowVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.3
  });
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: paragraphRef,
    isVisible: paragraphVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: quoteRef,
    isVisible: quoteVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: nextStepsRef,
    isVisible: nextStepsVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: dividerRef,
    isVisible: dividerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.3
  });
  const headlineLines = [{
    words: ["A", "service"],
    indent: "ml-0"
  }, {
    words: ["measured", "in"],
    indent: "ml-0 md:ml-24"
  }, {
    words: ["precision."],
    indent: "ml-0 md:ml-48"
  }];
  const paragraphWords = "Every journey begins as a commitment. We operate in deliberate, refined standards — never rushing the process, never compromising on quality. Each transit is a study in elegance, punctuality, and the quiet conversation between chauffeur, passenger, and destination.".split(" ");
  return <section data-section-id="2807" id="aboutbemaxbiography" className="relative bg-background text-foreground overflow-hidden py-32 md:py-48">
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        {}
        <div ref={eyebrowRef} className={`mb-16 md:mb-24 transition-all duration-700 ease-out ${eyebrowVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <span className="font-default text-xs tracking-[0.25em] uppercase" style={{
          color: "#7A7A7A"
        }}>
            02 &nbsp;/&nbsp; Our Story
          </span>
        </div>

        {}
        <div ref={headlineRef} className="mb-24 md:mb-32">
          <h2 className="font-default font-light leading-[0.95] text-foreground text-5xl md:text-7xl lg:text-[6.5rem]">
            {headlineLines.map((line, lineIdx) => <span key={lineIdx} data-index={lineIdx} className="block ml-0 !h-[80px] !w-auto">
                {line.words.map((word, wordIdx) => {
              const totalDelay = lineIdx * 300 + wordIdx * 120;
              return <span key={wordIdx} className="inline-block overflow-hidden align-bottom mr-[0.25em]">
                      <span className="inline-block transition-all duration-700 ease-out" style={{
                  transform: headlineVisible ? "translateY(0)" : "translateY(100%)",
                  opacity: headlineVisible ? 1 : 0,
                  transitionDelay: `${totalDelay}ms`
                }}>
                        {word}
                      </span>
                    </span>;
            })}
              </span>)}
          </h2>
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8 items-start">
          {}
          <div ref={imageRef} data-index={0} className={`md:col-span-4 md:self-center transition-all duration-1000 ease-out ${imageVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="aspect-square overflow-hidden rounded-lg shadow-lg">
              <Link className="w-full h-full object-cover underline cursor-pointer" to="/SecureChauffeurPage" newTab><img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722013/img/chauffeur_glove_door.webp" alt="Chauffeur opening the door of a luxury vehicle" loading="lazy" decoding="async" src="http://bemaxlimo.com/wp-content/uploads/2026/07/IMG_3201.webp" src="http://bemaxlimo.com/wp-content/uploads/2026/07/IMG_3201.avif" src="http://bemaxlimo.com/wp-content/uploads/2026/07/IMG_0705.heic" /></Link>
            </div>
          </div>

          {}
          <div ref={paragraphRef} data-index={1} className="md:col-span-4 md:mt-20">
            <p className="font-default text-lg md:text-xl leading-relaxed text-foreground">
              <span className="float-left font-default font-medium text-7xl md:text-8xl leading-[0.8] mr-3 mt-1" style={{
              color: "#000000"
            }}>
                E
              </span>
              {paragraphWords.map((word, wordIdx) => {
              if (wordIdx === 0) {
                return <span key={wordIdx} className="inline-block transition-all duration-700 ease-out mr-[0.25em]" style={{
                  opacity: paragraphVisible ? 1 : 0,
                  transform: paragraphVisible ? "translateY(0)" : "translateY(8px)",
                  transitionDelay: `${wordIdx * 35}ms`
                }}>Every</span>;
              }
              return <span key={wordIdx} className="inline-block transition-all duration-700 ease-out mr-[0.25em]" style={{
                opacity: paragraphVisible ? 1 : 0,
                transform: paragraphVisible ? "translateY(0)" : "translateY(8px)",
                transitionDelay: `${wordIdx * 35}ms`
              }}>
                    {word}
                  </span>;
            })}
            </p>
          </div>

          {}
          <div ref={quoteRef} data-index={2} className={`md:col-span-3 md:col-start-10 transition-all duration-1000 ease-out ${quoteVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="relative pl-6 border-l-2" style={{
            borderColor: "#C0C0C0"
          }}>
              <p className="font-default italic font-light text-3xl md:text-4xl leading-tight text-foreground">
                "We deliver
                <br />
                excellence."
              </p>
              <p className="mt-4 font-default text-xs tracking-widest uppercase" style={{
              color: "#7A7A7A"
            }}>
                — The Founder
              </p>
            </div>
          </div>
        </div>

        {}
        <div ref={nextStepsRef} data-index={3} className={`mt-20 md:mt-28 p-8 border border-secondary bg-card rounded-lg transition-all duration-1000 ease-out ${nextStepsVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="flex flex-col md:flex-row md:items-center justify-between gap-6">
            <div>
              <span className="font-mono text-xs tracking-[0.2em] uppercase" style={{
              color: "#7A7A7A"
            }}>
                03 &nbsp;/&nbsp; Action
              </span>
              <h3 className="font-default text-2xl md:text-3xl font-medium mt-1 text-foreground">
                Next Steps
              </h3>
            </div>
            <div className="flex flex-wrap items-center gap-8">
              <Link to="/SecureChauffeurPage" className="font-mono text-sm tracking-wider uppercase underline underline-offset-4 transition-colors hover:text-foreground" style={{
              color: "#C0C0C0"
            }}>
                Ready to Book?
              </Link>
              <Link to="/FleetPage" className="font-mono text-sm tracking-wider uppercase underline underline-offset-4 transition-colors hover:text-foreground" style={{
              color: "#C0C0C0"
            }}>
                View Fleet
              </Link>
            </div>
          </div>
        </div>

        {}
        <div ref={dividerRef} className={`mt-24 md:mt-36 flex items-center gap-4 transition-all duration-1000 ease-out ${dividerVisible ? "opacity-100" : "opacity-0"}`}>
          <Separator className="flex-1" style={{
          backgroundColor: "#E6E6E6"
        }} />
          <span className="inline-block size-1.5 rounded-lg" style={{
          backgroundColor: "#C0C0C0"
        }} aria-hidden="true" />
          <Separator className="flex-1" style={{
          backgroundColor: "#E6E6E6"
        }} />
        </div>
      </div>
    </section>;
}